import * as yup from "yup";

export const HospitalFormSchema = yup.object({
  hospital_Name: yup
    .string()
    .min(2, "Hospital name must be at least 2 characters")
    .max(50, "Hospital name must be at most 50 characters")
    .required("Hospital name is required"),
    hospital_email_id: yup
    .string()
    .email("Invalid email format")
    .required("Hospital email is required"),
  password: yup
    .string()
    .min(6, "Password must be at least 6 characters")
    .max(50, "Password must be at most 50 characters")
    .required("Password is required"),
  hospital_contact: yup
    .string()
    .min(8, "Hospital contact must be at least 8 digits")
    .max(8, "Hospital contact must be at most 8 digits")
    .required("Hospital contact is required"),
  hospital_region: yup
    .string()
    .min(2, "Hospital region must be at least 2 characters")
    .max(50, "Hospital region must be at most 50 characters")
    .required("Hospital region is required"),
    hospital_contact_person_name: yup
    .string()
    .min(2, "Hospital contact person name must be at least 2 characters")
    .max(50, "Hospital contact person name must be at most 50 characters")
    .required("Hospital contact person name is required"),
  hospital_address: yup
    .string()
    .min(2, "Hospital address must be at least 2 characters")
    .max(100, "Hospital address must be at most 100 characters")
    .required("Hospital address is required"),
  hospital_zio_code: yup
    .string()
    .min(4, "Hospital zip code must be at least 4 characters")
    .max(4, "Hospital zip code must be at most 4 characters")
    .required("Hospital zip code is required"),
    confirmPassword: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Passwords must match')
    .required('Password confirmation is required')
});

export const updateHospitalFormSchema = yup.object({
  hospital_Name: yup
    .string()
    .min(2, "Hospital name must be at least 2 characters")
    .max(50, "Hospital name must be at most 50 characters")
    .required("Hospital name is required"),
    hospital_email_id: yup
    .string()
    .email("Invalid email format")
    .required("Hospital email is required"),
  password: yup
    .string().optional()
    .min(6, "Password must be at least 6 characters")
    .max(50, "Password must be at most 50 characters"),
    
  hospital_contact: yup
    .string()
    .min(8, "Hospital contact must be at least 8 digits")
    .max(8, "Hospital contact must be at most 8 digits")
    .required("Hospital contact is required"),
  hospital_region: yup
    .string()
    .min(2, "Hospital region must be at least 2 characters")
    .max(50, "Hospital region must be at most 50 characters")
    .required("Hospital region is required"),
    hospital_contact_person_name: yup
    .string()
    .min(2, "Hospital contact person name must be at least 2 characters")
    .max(50, "Hospital contact person name must be at most 50 characters")
    .required("Hospital contact person name is required"),
  hospital_address: yup
    .string()
    .min(2, "Hospital address must be at least 2 characters")
    .max(100, "Hospital address must be at most 100 characters")
    .required("Hospital address is required"),
    hospital_zio_code: yup
    .string()
    .min(4, "Hospital zip code must be at least 4 characters")
    .max(4, "Hospital zip code must be at most 4 characters")
    .required("Hospital zip code is required"),
    confirmPassword: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Passwords must match')
    .required('Password confirmation is required')
});
